import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { IconAB, IconBook, IconRefresh, IconUsers } from '@tabler/icons';
import EarningCard from 'modules/Dashboard/components/cards/EarningCard';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import EndUsersCountsGraph from '../components/EndUsersCountsGraph';
import RecentUsers from '../components/RecentUsers';
import RegionsEndUsersCount from '../components/RegionsEndUsersCount';
import { DashboardStateSelector, getDashboardData } from '../store/slice';

const Dashboard = () => {
	const { globalCounts, isLoading } = useSelector(DashboardStateSelector);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getDashboardData({}));
	}, [dispatch]);

	return (
		<>
			<Helmet>
				<title>Dashboard</title>
			</Helmet>
			<Stack
				flexDirection='row'
				justifyContent={'space-between'}
				alignItems={'center'}
				marginBottom={4}
			>
				<Typography variant={'h1'}>Dashboard</Typography>
				<Tooltip title='Refresh'>
					<IconButton onClick={() => dispatch(getDashboardData({}))}>
						<IconRefresh />
					</IconButton>
				</Tooltip>
			</Stack>
			<Grid container spacing={2}>
				<Grid item md={4} xs={12}>
					<EarningCard
						isLoading={isLoading}
						title='Total users'
						content={globalCounts.totalUsers}
						icon={<IconUsers color='white' />}
					/>
				</Grid>
				<Grid item md={4} xs={12}>
					<EarningCard
						isLoading={isLoading}
						title='Total lessons'
						content={globalCounts.totalLessons}
						icon={<IconBook color='white' />}
					/>
				</Grid>
				<Grid item md={4} xs={12}>
					<EarningCard
						isLoading={isLoading}
						title='Total vocab words'
						content={globalCounts.totalVocabWords}
						icon={<IconAB color='white' />}
					/>
				</Grid>

				<Grid item md={8} xs={12} marginY={2}>
					<EndUsersCountsGraph />
				</Grid>

				<Grid item md={4} xs={12} marginY={2}>
					<RecentUsers />
				</Grid>
				<Grid item xs={12} marginY={2}>
					<RegionsEndUsersCount />
				</Grid>
			</Grid>
		</>
	);
};

export default Dashboard;
